import LogoutIcon from '@mui/icons-material/Logout';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import TokenService from "src/services/token";
import { useNavigate } from "react-router-dom";

import {
    setUserMessage, resetStore
} from 'src/reducers/basicReducer';
import { useDispatch } from 'react-redux'

// import TokenService from "src/services/token";
// import { useNavigate } from "react-router-dom";
// import {
//     setUserMessage
// } from 'src/reducers/basicReducer';
// import { useDispatch } from 'react-redux'

// let navigate = useNavigate();
// let dispatch = useDispatch()

// const logout = () => {
//     dispatch(setUserMessage("Log out successful")) // TODO - consider if this message should disappear when user hits "sign in" button (even if invalid)
//     console.log("NAVIGATING TO LOGIN 3");
//     TokenService.removeUser();
//     navigate("/login");
// }

const SignOut = () => {

    // https://stackoverflow.com/questions/50644976/react-button-onclick-redirect-page
    let navigate = useNavigate();
    let dispatch = useDispatch()

    const logout = () => {
        dispatch(resetStore());
        dispatch(setUserMessage("Log out successful")) // TODO - consider if this message should disappear when user hits "sign in" button (even if invalid)
        console.log("NAVIGATING TO LOGIN 3");
        TokenService.removeUser();
        navigate("/login");
    }

    return (
        <ListItemButton onClick={logout}>
            <ListItemIcon>
                <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Log out" />
        </ListItemButton>
    );
}

export default SignOut;